import React from 'react'
import { Table, Th, Tr } from 'styling/GlobalStyles'
import { Td } from 'components/Td/Td'
import {
  AnalyticsTableWrapper,
  RateCell,
  RateBar,
  RateValue,
} from '../HrAnalytics.styled'

export interface ColumnDef {
  key: string
  label: string
  sortable?: boolean
  width?: string
  renderCell?: (value: any, row: any) => React.ReactNode
}

interface IAnalyticsTable {
  columns: ColumnDef[]
  data: any[]
  minWidth?: string
}

const getRateColor = (value: number): string => {
  if (value >= 90) return '#00B04C'
  if (value >= 70) return '#ff9900'
  return '#FF4F46'
}

export const RateCellRenderer = ({ value }: { value: number }) => {
  const color = getRateColor(value)
  return (
    <RateCell>
      <RateBar percent={value} color={color} />
      <RateValue color={color}>{value}%</RateValue>
    </RateCell>
  )
}

export const RedValueRenderer = ({ value }: { value: number | string }) => {
  return <span style={{ color: '#FF4F46', fontWeight: 600 }}>{value}</span>
}

export const AnalyticsTable = ({ columns, data, minWidth }: IAnalyticsTable) => {
  return (
    <AnalyticsTableWrapper>
      <Table>
        <Th minWidth={minWidth || '50rem'}>
          {columns.map((col) => (
            <Td key={col.key} w={col.width || `${100 / columns.length}%`} noTooltip text={col.label} />
          ))}
        </Th>
        {data.map((row, idx) => (
          <Tr key={idx} minWidth={minWidth || '50rem'}>
            {columns.map((col) => (
              <Td key={col.key} w={col.width || `${100 / columns.length}%`}>
                {col.renderCell ? col.renderCell(row[col.key], row) : row[col.key]}
              </Td>
            ))}
          </Tr>
        ))}
      </Table>
    </AnalyticsTableWrapper>
  )
}
